var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.params.categoryId)?_c('router-view'):_c('Department')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }